import React, { useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import CustomTabs from 'components/CustomTabs'
import TemplateCard from 'components/TemplateCard'
import ResourceNotFound from 'components/ResourceNotFound'
import Wrapper from 'components/Wrapper'
import { makeStyles } from '@material-ui/core'
import { toast } from 'utils/notify'
import { useDispatch, useSelector } from 'react-redux'
import { fetchConfig, updateConfigById } from 'store/config'
import { Roles } from 'constants/index'
import ViewHeader from 'components/ViewHeader'
import { templateTypes } from 'views/admin/EmailTemplates/Templates'

const DefaultEmailTemplates = () => {
  const classes = useStyles()
  const [value, setValue] = useState('Organization')
  const [isLoading, setIsLoading] = useState(false)
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const { config, inProgress } = useSelector((state) => state.config)

  useEffect(() => {
    dispatch(fetchConfig())
  }, [dispatch])

  const onSaveTemplate = async (newValues, template, closeModal) => {
    if (user?.role === Roles.SUPER_ADMIN) {
      startLoading()
      await dispatch(
        updateConfigById(
          config?.id,
          {
            emailTemplates: {
              ...config?.emailTemplates,
              [template?.id]: {
                subject: newValues?.subject?.trim(),
                body: newValues?.body?.trim()
              }
            }
          },
          () => {
            toast.success('Email template saved.')
            stopLoading()
          },
          () => {
            toast.error('Could not save template. Try again.')
            stopLoading()
          }
        )
      )
      closeModal()
    }
  }

  const startLoading = () => setIsLoading(true)

  const stopLoading = () => setIsLoading(false)

  return (
    <div>
      <ViewHeader title="Default Email Templates" />
      <CustomTabs
        tabs={Object.values(templateTypes).map((t) => t.label)}
        activeTab={value}
        valueKey="label"
        onChange={(val) => setValue(val)}
      />
      <Wrapper inProgress={inProgress}>
        {value && templateTypes?.[value.toLowerCase()] ? (
          <Stack gap={2} mt={2} className={classes.cards}>
            {templateTypes[value.toLowerCase()].items
              .map((item) => ({
                name: item?.name,
                subject: config?.emailTemplates?.[item?.id]?.subject || '',
                body: config?.emailTemplates?.[item?.id]?.body || '',
                id: item?.id
              }))
              .map((item) => (
                <TemplateCard
                  key={item.id}
                  id={item.id}
                  template={item}
                  isLoading={isLoading}
                  templateId={item.id}
                  onSaveTemplate={(values, closeModal) => onSaveTemplate(values, item, closeModal)}
                />
              ))}
          </Stack>
        ) : (
          <ResourceNotFound message="No email templates available" />
        )}
      </Wrapper>
    </div>
  )
}

export default DefaultEmailTemplates

const useStyles = makeStyles((theme) => ({
  headBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '1rem',
    zIndex: 99,
    position: 'sticky',
    top: 0,
    background: theme.palette.background.paper,
    marginBottom: '2rem',
    padding: '1rem 0'
  },
  subText: {
    marginTop: '2px',
    color: '#979797',
    lineHeight: '10px'
  },
  toggleGroup: {
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      fontWeight: 500,
      padding: '6px 16px'
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    }
  },
  card: {
    padding: '1rem',
    border: '1px solid #E0E0E0',
    borderRadius: '8px'
  },
  label: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#4A4A4A',
    letterSpacing: '0.5px',
    marginRight: '1rem'
  },
  header: {
    background: '#CAEDF5',
    padding: '12px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    marginBottom: '1rem'
  },
  title: {
    color: 'rgb(66, 66, 66)',
    fontWeight: 600,
    fontSize: '16px',
    letterSpacing: '0.8px'
  },
  attendanceModule: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '16px'
  },
  headingLabel: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '16px',
    letterSpacing: '0.8px'
  },
  timePicker: {
    width: '100%'
  }
}))
